/**
 * ErrorAlert Component
 *
 * Thin wrapper around Alert with variant="error".
 * Preserved for backward compatibility — 44 existing imports.
 *
 * For new code, prefer using Alert directly:
 *   <Alert variant="error" message="..." />
 *
 * @component
 * @param {Object} props
 * @param {string} props.message - Error message to display
 * @param {string} [props.className] - Additional classes to merge
 */
import PropTypes from 'prop-types';
import Alert from './Alert';

export default function ErrorAlert({ message, className = '' }) {
  return <Alert variant="error" message={message} className={className} />;
}

ErrorAlert.propTypes = {
  message: PropTypes.string.isRequired,
  className: PropTypes.string,
};
